var _rect, _path, _path2, _circle, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDugoutIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 6,
    fill: "#0A0C11"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 8 A8 8 0 0 1 19 8",
    stroke: "#3DA8FC",
    strokeWidth: 1.7,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 16 A8 8 0 0 1 5 16",
    stroke: "#F2B142",
    strokeWidth: 1.7,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 8,
    r: 2.2,
    fill: "#3DA8FC"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 16,
    r: 2.2,
    fill: "#F2B142"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDugoutIcon);
export default __webpack_public_path__ + "static/media/dugout-icon.4183cdf76b7fb1aab2e383574b263a24.svg";
export { ForwardRef as ReactComponent };